import * as _ from "lodash"

import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

import {WB_FinishedProductRow} from "../PA.Core/PAdbSchemaRows";
import {ASync} from "../PA.Core/Basic/ASync";


const vWB_Prod_Fields: {[id:string]: ISearchProviderField } = {
  WB_PROD_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Id',          columnResourceName: 'colPrdWbId',      alignment: HorizAlignment.Center}, domainOptions: {}},
  PRODUCT_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Id',     columnResourceName: 'colPrdId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  PRODUCT_SET_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Set Id',         columnResourceName: 'colSetID',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 20}},
  SOURCE_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source ID',      columnResourceName: 'colSourceID',     alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  PRODUCT_NAME:         {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name',           columnResourceName: 'colPrdName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
  WB_PROD_TYPE_ID:         {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Type',   columnResourceName: 'colPrdType',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  STATUS_CODE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Status Cd',      columnResourceName: 'colPrdStatusCd',  alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  PRODUCT_UPC:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product UPC',    columnResourceName: 'colPrdUPC',       alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  CONSUMER_PRODUCT_UPC: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Consumer UPC',   columnResourceName: 'colCnsProdUPC',   alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  BASE_UOM:             {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Base UOM',       columnResourceName: 'colBaseUOM',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  CASE_PACK_SIZE:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Case Pack',      columnResourceName: 'colCasePack',     alignment: HorizAlignment.Right, numberFormat: "#,##0.#"},  domainOptions: { }},
  STAT_CS_FACTOR:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Stat Cs Factor', columnResourceName: 'colStatCsFactor', alignment: HorizAlignment.Right, numberFormat: "#,##0.00"},  domainOptions: { }},
  WEIGHT_FACTOR:        {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Weight Factor',  columnResourceName: 'colWeightFactor', alignment: HorizAlignment.Right, numberFormat: "#,##0.00"},  domainOptions: { }},
  WEIGHT_UOM:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Weight UOM',     columnResourceName: 'colWeightUOM',    alignment: HorizAlignment.Left},   domainOptions: { maxLength: 20}},
  UNIT_SIZE:            {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Unit Size',      columnResourceName: 'colUnitSize',     alignment: HorizAlignment.Right, numberFormat: "#,##0.00"},  domainOptions: { }},
  UNIT_UOM:             {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Unit UOM',       columnResourceName: 'colUnitUOM',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 20}},
  TREE_PATH:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tree Path',      columnResourceName: 'colTreePath',     alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}}
}

const vWB_Prod_KeyFields =
  {id:    'WB_PROD_ID',
   id_ui: 'PRODUCT_ID',
   name:  'PRODUCT_NAME'}


class ProductSearchByListSearchProvider
  implements  ISearchProvider {

  arrWB_ProductRows:WB_FinishedProductRow[] = []

  constructor(WB_ProductRows: WB_FinishedProductRow[]){
    this.arrWB_ProductRows = WB_ProductRows

  }

  get keyFields() { return vWB_Prod_KeyFields }

  get searchProviderFields(){
    return vWB_Prod_Fields
  }

  search(requestSpec: ISearchRequestSubset): Promise<any[]> {
    return ASync.resolve(_.map(this.arrWB_ProductRows, (aWB_ProdRow: WB_FinishedProductRow) => {
      return aWB_ProdRow.toJSON()
    }))
  }

}


class ProductSearchByListSearchProfile
  implements  ISearchProfile {

  aSearchProvider: ISearchProvider = undefined

  profileId = "default"
  profileName = "AutoSearch Only"
  renderOptions = { ui5ResourceId: "ProductSearchByListProfile" }

  profileFilter: IProfileFilter[] = []

  profileDisplayFields = [
    'PRODUCT_ID','PRODUCT_NAME','PRODUCT_SET_ID','SOURCE_ID','WB_PROD_TYPE_ID','PRODUCT_UPC','CONSUMER_PRODUCT_UPC','CASE_PACK_SIZE', 'WEIGHT_FACTOR'
    ]

  profileTreeIdDefault = "default"
  profileTrees: ITree[] = [
    {treeId: "default",
     treeName: "By Hierarchy",
     nodeProviders: [ new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "No Product Group Set", levelDelimiter: "\\", ruggedTree: true})],
     renderOptions: {}},
    {treeId: "consUPC",
      treeName: "By Consumer UPC",
      nodeProviders: [ new ColumnNodeProvider(['CONSUMER_PRODUCT_UPC'], {defaultValues: "No Consumer UPC", levelDelimiter: "\\", ruggedTree: true})],
      renderOptions: {}},
  ]

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault = ""    //string;
  profileSorts: ISearchSort[] = [] //ISearchSort[];


  constructor(WB_ProductRows: WB_FinishedProductRow[]){
    this.aSearchProvider = new ProductSearchByListSearchProvider(WB_ProductRows)
  }

  get profileSearchProvider(){ return this.aSearchProvider }

}


export class ProductSearchByList
implements  ISearch {

  constructor(WB_ProductRows: WB_FinishedProductRow[], options?: any){
    this.searchProfiles = [ new ProductSearchByListSearchProfile(WB_ProductRows) ]
  }

  searchName = "Select Products"
  renderOptions = { ui5ResourceId: "ProductSearchByList"}
  searchProfileIdDefault = "default"
  searchProfiles: ISearchProfile[] = []
  autoSearch = true


}
